export default "__VITE_ASSET__o7gysxRn__"